export default "__VITE_PUBLIC_ASSET__5e66811d__"